import React, { FC, Fragment, useState } from 'react';
import classNames from 'classnames';

import Button from 'b2b-ui-components-lib/lib/components/button';
import Accordion from 'b2b-ui-components-lib/lib/components/accordion';

import FileUpload from 'featureLib/FileUpload';

import { ClickEventType, FileTypes } from 'home/view/check-feasibility/comp-generator/common-interface';
import { getInstallationDetailsAccordionHeading, getInstallationDetailsAccordionHeadingAOI } from 'home/view/check-feasibility/comp-generator/component.generator';

import downloadIcon from '../../assests/download.svg';
import './index.scss';
import { isAOIOrder } from 'common/constants/app.constants';

interface FileUploadCbProps {
  fileList: FileList;
  error: string;
  setFileError: React.Dispatch<React.SetStateAction<string | React.ReactNode>>;
  setDownloadPercentage: React.Dispatch<React.SetStateAction<number>>;
}

interface ExtendedFileUploadCbProps extends FileUploadCbProps {
  setIsSubmitDisabled: React.Dispatch<React.SetStateAction<boolean>>;
}

interface Props {
  downloadButtonName?: string;
  OnDownloadClick?: (setIsDownloadDisabled: React.Dispatch<React.SetStateAction<boolean>>) => void;
  onDownloadTemplate?: (setIsDownloadDisabled: React.Dispatch<React.SetStateAction<boolean>>) => void;
  format: FileTypes;
  size: number;
  onUploadCb?: (extendedFileData: ExtendedFileUploadCbProps) => void;
  submitButtonName?: string;
  cancelButtonName?: string;
  onSubmitClick?: (e: ClickEventType) => void;
  onCancelClick?: (e: ClickEventType) => void;
  abortController?: AbortController;
}

export const InstallationDetails: FC<Props> = ({
  downloadButtonName = 'Download Template',
  OnDownloadClick,
  onDownloadTemplate,
  format,
  size,
  onUploadCb,
  submitButtonName = 'Next',
  cancelButtonName = 'Cancel',
  onSubmitClick,
  onCancelClick,
  abortController
}) => {
  const [isDownloadDisabled, setIsDownloadDisabled] = useState<boolean>(false);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState<boolean>(true);

  const handleFileUpload = (fileCbData: FileUploadCbProps) => {
    const combinedProps = { ...fileCbData, setIsSubmitDisabled };
    onUploadCb?.(combinedProps);
  };

  const handleDownloadClick = (e: ClickEventType) => {
    e.preventDefault();
    OnDownloadClick?.(setIsDownloadDisabled);
  };

  const handleDownloadTemplate = (e: ClickEventType) => {
    e.preventDefault();
    onDownloadTemplate?.(setIsDownloadDisabled);
  };

  const linkBtnClassNames = classNames({
    'link-button': true,
    disabled: isDownloadDisabled
  });

  const getMultiSiteSubTextAOI = (onDownloadTemplateClick = (e: ClickEventType) => {}): React.ReactNode => {
    return (
      <Fragment>
        <span className="sub-heading" style={{ paddingLeft: '12px', fontSize: '14px' }}>
          Upload .xls file with complete site details to get the accurate network feasibility report.
        </span>
        <span className="sub-heading" style={{ paddingLeft: '12px', fontSize: '14px' }}>
          You can download the template according to your product selection above and upload up to 1000 sites.
        </span>
      </Fragment>
    );
  };

  if (isAOIOrder()) {
    return (
      <div className="installation-details">
        <Accordion title={getInstallationDetailsAccordionHeadingAOI(false, { id: '' }, handleDownloadClick)} variant="round" isExpanded={true}>
          {getMultiSiteSubTextAOI()}
          <Fragment>
            <div className="download-section">
              {/* <img src={downloadIcon} className="icon" />
            <div className={linkBtnClassNames} role="button">
              Download Existing Circuits
            </div>
            <span className="or_text">Or</span> */}
              <img src={downloadIcon} className="icon" />
              <div className={linkBtnClassNames} role="button" onClick={handleDownloadTemplate}>
                {downloadButtonName}
                {isDownloadDisabled && <span className="loading_icon link_loading_icon"></span>}
              </div>
            </div>

            <FileUpload format={[format]} size={size} onFileUpload={handleFileUpload} abortController={abortController} />

            {/* <div className="submit-section">
            <Button displayName={cancelButtonName} buttonClass="button-class cancel-button" variant="outlinebtn" onClick={onCancelClick} />
            <Button displayName={submitButtonName} buttonClass="button-class" onClick={onSubmitClick} disabled={isSubmitDisabled} />
          </div> */}
          </Fragment>
        </Accordion>
      </div>
    );
  }

  return (
    <div className="installation-details">
      <Accordion title={getInstallationDetailsAccordionHeading(false, { id: '' }, handleDownloadClick)} variant="round" isExpanded={true}>
        <Fragment>
          <div className="download-section">
            {/* <img src={downloadIcon} className="icon" />
            <div className={linkBtnClassNames} role="button">
              Download Existing Circuits
            </div>
            <span className="or_text">Or</span> */}
            <img src={downloadIcon} className="icon" />
            <div className={linkBtnClassNames} role="button" onClick={handleDownloadTemplate}>
              {downloadButtonName}
              {isDownloadDisabled && <span className="loading_icon link_loading_icon"></span>}
            </div>
          </div>

          <FileUpload format={[format]} size={size} onFileUpload={handleFileUpload} abortController={abortController} />

          <div className="submit-section">
            <Button displayName={cancelButtonName} buttonClass="button-class cancel-button" variant="outlinebtn" onClick={onCancelClick} />
            <Button displayName={submitButtonName} buttonClass="button-class" onClick={onSubmitClick} disabled={isSubmitDisabled} />
          </div>
        </Fragment>
      </Accordion>
    </div>
  );
};

export default InstallationDetails;
